export default function() {
  const checkAllItems = document.querySelector('input[name="check_all_items"]');

  if (!checkAllItems) {
    return;
  }

  const worksListStatusForm = document.querySelector('#works-list-status-form');
  const worksListJudgingForm = document.querySelector('#works-list-judging-form');

  if (!worksListStatusForm && !worksListJudgingForm) {
    return;
  }


  checkAllItems?.addEventListener('change', function (e) {
    const checkedItems = document.querySelectorAll('input[name="checked_items[]"]');

    let allChecked = false;

    if (checkAllItems.checked) {
      allChecked = true;
    }

    checkedItems.forEach(function (item) {
      item.checked = allChecked;
    });
  });
}